import { Button, Drawer, Input, Slider } from "antd";
import { useState } from "react";

export default function WelcomeComp({coreState, coreSetState}){

    const [showTriggerModal, setShowTriggerModal] = useState(false)

    return(
        <div className="flow-comp">
            <p className="comp-title" onClick={() => setShowTriggerModal(true)} >Welcome Message</p>
            <h2 className="">Welcome Message</h2>
            <p className="">Hello world thois ioasksd fslmfsdf </p>
            <p>Button</p>
            <Drawer open={showTriggerModal} onClose={() => setShowTriggerModal(false)}>
                <div className="btn-msg">
                    <Input className="btn-msg-title" placeholder="Message title"/>
                    <Input.TextArea className="btn-msg-desc" placeholder="Message Description"/>
                    <Input className="btn-msg-btn" placeholder="Proceed" style={{textAlign:"center"}}/>
                </div>
                <div className="waiting-comp">
                    <p>Waiting</p>
                </div>
            </Drawer>
        </div>
    )

}